import { ProvisioningUser } from "../types";

type CardProps = {
  label: string;
  value: string | null;
  href?: string | null;
};

function Card({ label, value, href }: CardProps) {
  const display = value ?? "—";
  return (
    <div className="bg-neutral-50 border border-border-primary rounded p-3 flex-1 min-w-[180px]">
      <div className="text-xs text-content-secondary uppercase tracking-wide mb-1">
        {label}
      </div>
      {href && value ? (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm font-medium text-brand-primary hover:underline break-all"
        >
          {display}
        </a>
      ) : (
        <div className="text-sm font-medium text-content-primary break-all">
          {display}
        </div>
      )}
    </div>
  );
}

export function ResourceCards({ user }: { user: ProvisioningUser }) {
  const adsLink = user.googleAdsCustomerId
    ? `https://ads.google.com/aw/overview?ocid=${user.googleAdsCustomerId}`
    : null;
  const ga4Link = user.googleAnalyticsPropertyId
    ? `https://analytics.google.com/analytics/web/#/p${user.googleAnalyticsPropertyId}/admin/streams/table`
    : null;
  const gtmLink = user.gtmContainerPublicId
    ? `https://tagmanager.google.com/#/home`
    : null;

  return (
    <div className="flex flex-wrap gap-3">
      <Card
        label="Google Ads"
        value={user.googleAdsCustomerId}
        href={adsLink}
      />
      <Card
        label="GA4 Property"
        value={user.googleAnalyticsPropertyId}
        href={ga4Link}
      />
      <Card
        label="GA4 Measurement ID"
        value={user.ga4MeasurementId}
      />
      <Card
        label="GTM Container"
        value={user.gtmContainerPublicId}
        href={gtmLink}
      />
    </div>
  );
}
